<template ref="meetings">
  <div>
    <div v-if="!isLoading">
      <appMeetingsNav />
      <router-view
        v-if="$route.name != 'meetings' && $_.isObject(currentMeeting)"
        :building-owners="buildingOwners"
        :current-building-owner="currentBuildingOwner"
        :current-meeting="currentMeeting"
        :steps="steps"
        :mandate="mandate"
      />
      <b-container v-else fluid="md">
        <b-row>
          <appMeetingsTable />
        </b-row>
        <b-row v-if="meeting_guest_id" class="my-5 justify-content-center">
          <b-col cols="auto">
            <b-button variant="light" class="button text-danger" @click="logout">
              <font-awesome-icon class="agv-button-icon" icon="sign-out-alt" />
              <span class="mr-2">Se déconnecter</span>
            </b-button>
          </b-col>
        </b-row>
      </b-container>
    </div>
    <appLoader v-else />
  </div>
</template>
<script>
import MandateORM from "@/store/orm-axios/models/Mandate";
import BuildingOwnerORM from "@/store/orm-axios/models/BuildingOwner";
import MeetingORM from "@/store/orm-axios/models/Meeting";

import moment from "moment";

export default {
  name: "Meetigns",
  components: {
    appMeetingsNav: () => import("@/components/Meetings/MeetingsNav"),
    appMeetingsTable: () => import("@/components/Meetings/MeetingsTable"),
  },
  data() {
    return {
      steps: {},
      isLoading: true,
      currentMeeting: null,
      myMeetings: null,
      meetingFields: [
        {
          label: "Immeuble",
          key: "building.name",
          sortable: true,
        },
        {
          label: "Nom convocation",
          key: "name",
          sortable: true,
        },
        {
          label: "Date",
          key: "meeting_date",
          sortable: true,
          formatter(value, key, item) {
            return moment(item.meeting_date).format("DD/MM/YYYY");
          },
        },
        {
          label: "Modalités d’accès",
          key: "access",
          sortable: false,
        },
        // {
        //   key: "meeting_resolutions",
        //   label: "Résolutions",
        //   sortable: false,
        //   formatter(value, key, item) {
        //     var counter = 0;
        //     item.meeting_resolutions.forEach(el => {
        //       if (el.parent_resolution_id == null) {
        //         counter++;
        //       }
        //     });
        //     return counter;
        //   },
        // },
        // {
        //   key: "mandate",
        //   label: "État",
        //   sortable: false,
        // },
        {
          label: "Actions",
          key: "actions",
          class: "justify-content-center",
        },
      ],
      mandate: null,
    };
  },
  computed: {
    meetings() {
      var p = [];
      this.$_.each(this.mandates, mandate => {
        var meeting = MeetingORM.query()
          .where("id", mandate.meeting_id)
          .withAllRecursive(3)
          .first();
        // !!!: comment the status change
        if (meeting) {
          p.push(meeting);
        }
      });
      return p;
    },
    allMandates() {
      return MandateORM.all();
    },
    mandates() {
      let mandate = MandateORM.query()
        .where("building_owner_id", this.building_owner_id)
        .get();
      return mandate;
    },
    currentBuildingOwner() {
      let buildingOwner = BuildingOwnerORM.query("id", this.building_owner_id)
        .where()
        .withAllRecursive()
        .first();
      return buildingOwner;
    },
  },
  async created() {
    this.myMeetings = this.meetings;
    this.isLoading = false;
  },
  methods: {
    logout() {
      this.$store.dispatch("auth/logout").then(() => {
        this.$parent.selectedBuilding = null;
        this.$router.push({ name: "login" });
      });
    },
    getEtat(item) {
      // here item is a meeting
      if (item) {
        if (item.status == this.meetingStatuses.completed) return "Clôturée";
        var mandate = MandateORM.query()
          .where("building_owner_id", this.currentBuildingOwner.id)
          .where("meeting_id", item.id)
          .withAllRecursive(1)
          .first();
        if (mandate) {
          if (mandate.presence_status != null) {
            var key = Object.keys(this.mandatePresenceStatuses).find(
              key => this.mandatePresenceStatuses[key] === mandate.presence_status
            );
            return this.makeTitle(key);
          } else {
            return "";
          }
        } else {
          console.log("mandate not found");
          return "";
        }
      }
    },
    makeTitle(slug) {
      slug = slug.replace("_", " ");
      var words = slug.split("-");

      for (var i = 0; i < words.length; i++) {
        var word = words[i];
        words[i] = word.charAt(0).toUpperCase() + word.slice(1);
      }
      return words.join(" ");
    },
  },
};
</script>

<style>
.table-bordered th,
.table-bordered td {
  vertical-align: middle !important;
}
</style>
